import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lane"]

  reveal(event) {
    const optionId = event.currentTarget.dataset.optionId
    this.laneTargets.find((lane) => lane.dataset.optionId === optionId).hidden = false
    event.currentTarget.hidden = true
  }
}
